import { LOAD_PIXEL_SERVER } from 'constants/reduxActions';
import { postMartyPixel } from 'apis/martyPixel';
import { getPageLang } from 'helpers/ClientUtils';
import { fetchMartyPixelErrorMiddleware } from 'middleware/fetchErrorMiddleware';
import logger from 'middleware/logger';

/**
 * Indicates that the pixel server should post the given data to the pixel server once the page is ready. See https://s3.amazonaws.com/pixels.zappos.com/page/6pm-home.html for what information to send on each page
 * @param  {String} pageType             the "pageType" key from the pixel bucket
 * @param  {Object} [trackingPayload={}] Additional data to post to the server for this pageType
 * @param  {String} [pageId='']          an additional identifer when combined with pageType to use when determining when to fire the pixel server message.  For instance to identify client routing between different product pages. (not sent to pixel server)
 */
export function firePixelServer(pageType, trackingPayload = {}, pageId = '') {
  return function(dispatch, getState) {
    const { routing: { locationBeforeTransitions: { search } } } = getState();
    dispatch({
      type: LOAD_PIXEL_SERVER,
      pageType,
      pageId,
      trackingPayload,
      pageLang: getPageLang(),
      queryString: search
    });
  };
}

export function fireMartyPixel(qs, type, endpoints = { postMartyPixel }) {
  return function() {
    return endpoints.postMartyPixel(`type=${type}&${qs}`)
      .then(fetchMartyPixelErrorMiddleware)
      .catch(() => {
        logger('Unable to get valid response from /martypixel endpoint, not firing marty pixel server.');
      });
  };
}
